<template>
  <Modal :title="title" v-model="pointsModal" className="iv-points-info-modal">
    <div class="iv-p-t-12 iv-p-24">
      <FormLayout :readOnly="true" :model="partyMemberInfo" :list="partyMember"></FormLayout>
      <LayoutTitle :title="personTitle" >
        <DragTable
          noSearch
          class="iv-m-t-24"
          :showSelect="false" 
          ref="DragTable"
          :immediateForce="true" 
          :columns="rewardColumn" 
          :showPage="false"
          :showEdit="false"
          :showDelete="false"
          :tableData="rewardData">
        </DragTable>
      </LayoutTitle>
    </div>
    <div slot="footer">
      <Button type="close" @click="refusePointsModal">关闭</Button>
    </div>
  </Modal>
</template>

<script>
import { timeFormat } from '@/utils'
import Modal from '@/components/modal'
import { personColumn } from './column.js'
import FormLayout from '@/components/layout/form'
import DragTable from '@/components/drag-table-inline'
import LayoutTitle from '@/components/layout/layout-title'

export default {
  data () {
    return {
      pointsModal: false,
      partyMemberInfo: {},
      rewardData: [],
      title: '',
      personTitle: '',
      partyMember: [],
      rewardColumn: [],
      dictMap: {}
    }
  },
  created () {
    this.getCodeTable('GG56')
    this.personColumn = personColumn.call(this)
  },
  methods: {
    open (data) {
      if (data.rewardType == -2) {
        this.title = '惩处信息'
        this.personTitle = '惩处人员'
        this.punishList()
        this.setPunishColumn()
      } else {
        this.title = '奖励信息'
        this.personTitle = '获奖人员'
        this.rewardList()
        this.setTableColumns()
      }
      this.getDetail(data.rewardUserId, data.rewardOrgId)
      this.pointsModal = true
    },
    getDetail (rewardUserId, rewardOrgId) {
      this.$ajax({
        url: 'api-uum/module/reward/getRewardUserOrOrg',
        method: 'GET',
        data: {
          rewardUserId: rewardUserId,
          rewardOrgId: rewardOrgId
        }
      }).then(({data}) => {
        this.partyMemberInfo = data.data
        this.partyMemberInfo.rewardDate = this.partyMemberInfo.rewardDate ? new Date(this.partyMemberInfo.rewardDate) : ''
        this.partyMemberInfo.punishmentRevocationTime = this.partyMemberInfo.punishmentRevocationTime ? new Date(this.partyMemberInfo.punishmentRevocationTime) : ''
        this.rewardData = [data.data.rewardUserOrOrg]
        if (this.partyMemberInfo.rewardKindName.indexOf('手填') > -1) {
          this.partyMember.splice(5, 0, {
            title: '（其他）奖励名称',
            [$field]: 'rewardName',
            ref: 'rewardName',
            rules: ['required']
          })
        }
        this.getActivityFiles(this.partyMemberInfo.rewardFileId, 'handleUploadFile')
      })
    },
    refusePointsModal () {
      this.pointsModal = false
    },
    //获取文件信息
    getActivityFiles (groupId, key) {
      this.$ajax({
        url: 'api-uum/file/listFilesByGroupId',
        method: 'GET',
        data: {
          isPage: false,
          groupId: groupId
        }
      }).then(({data}) => {
        this.$set(this.partyMemberInfo, key, data.data || [])
      })
    },
    //奖励列表
    rewardList () {
      this.partyMember = [
        {
          type: 'year',
          title: '年度',
          [$field]: 'rewardYear',
          rules: ['required']
        },
        {
          type: 'DatePicker',
          title: '获奖日期',
          [$field]: 'rewardDate',
          rules: ['required']
        },
        {
          title: '奖励级别',
          [$field]: 'rewardLevel',
          rules: ['required'],
          optionList: []
        },
        {
          title: '奖励名称类别',
          colSpan: 16,
          [$field]: 'levelType',
          ref: 'levelType',
          rules: ['required'],
          optionList: []
        },
        {
          title: '奖励名称',
          [$field]: 'rewardKindName',
          ref: 'rewardKindName',
          rules: ['required']
        },
        {
          type: 'Input',
          title: '颁发单位',
          [$field]: 'approvalOrgName',
          rules: ['required']
        },
        {
          type: 'FileUpload',
          title: '附件资料',
          colSpan: 24,
          [$field]: 'handleUploadFile',
          props: {
            data: {
              groupId: this.groupId
            },
            multiple: true,
            isShowFileList: true,
            formatText: '支持word、pdf格式，附件大小不超过5M。请勿上传违反国家法律法规或不宜网络公开的资料。',
            accept: '.docx,.doc,.pdf'
          },
          rules: ['']
        }
      ]
    },
    //惩处列表
    punishList () {
      this.partyMember = [
        {
          type: 'year',
          title: '年度',
          [$field]: 'rewardYear',
          rules: ['required']
        },
        {
          title: '惩处级别',
          [$field]: 'rewardLevel',
          rules: ['required'],
          optionList: []
        },
        {
          type: 'Input',
          title: '惩处批准组织',
          [$field]: 'approvalOrgName',
          rules: ['required']
        },
        {
          type: 'DatePicker',
          title: '惩处日期',
          [$field]: 'rewardDate',
          rules: ['required']
        },
        {
          type: 'textarea',
          title: '惩处原因补充',
          [$field]: 'rewardReasonAdded',
          colSpan: 24,
          rules: ['required']
        },
        {
          type: 'SelectTree',
          title: '惩处结果',
          [$field]: 'rewardCode',
          rules: ['required'],
          colSpan: 16,
          props: {
            treeType: 'tireTree',
            url: 'module/dict/outGetCheckboxList',
            map: {
              title: 'title',
              value: 'value'
            },
            params: {
              dictCode: 'DM27B',
              merge: false
            }
          }
        },
        {
          type: 'textarea',
          title: '惩处说明',
          rows: 3,
          [$field]: 'rewardExplanation',
          colSpan: 24,
          rules: ['required']
        },
        {
          type: 'DatePicker',
          title: '惩处撤销日期',
          [$field]: 'punishmentRevocationTime',
          rules: ['required']
        },
        {
          type: 'FileUpload',
          title: '附件资料',
          colSpan: 24,
          [$field]: 'handleUploadFile',
          props: {
            data: {
              groupId: this.groupId
            },
            multiple: true,
            isShowFileList: true,
            formatText: '支持word、pdf格式，附件大小不超过5M。请勿上传违反国家法律法规或不宜网络公开的资料。',
            accept: '.docx,.doc,.pdf'
          },
          rules: ['']
        }
      ]
    },
    //奖励人员列表
    setTableColumns () {
      this.rewardColumn = [
        {
          title: '获奖人员',
          [$field]: 'userName'
        },
        {
          title: '工号',
          [$field]: 'userCode'
        },
        {
          title: '所在组织全称',
          [$field]: 'orgName'
        },
        {
          title: '所在组织简称',
          [$field]: 'orgShortName'
        },
        {
          title: '获奖名次',
          [$field]: 'prizeAwarded',
          render: (h, {row, index}) => {
            return h('span', this.dictMap['GG56'][row.prizeAwarded])
          }
        },
        {
          title: '团队/项目名称',
          [$field]: 'groupName'
        }
      ]
    },
    //惩处人员列表
    setPunishColumn () {
      this.rewardColumn = [
        {
          title: '惩处人员',
          [$field]: 'userName'
        },
        {
          title: '工号',
          [$field]: 'userCode'
        },
        {
          title: '所在组织全称',
          [$field]: 'orgName'
        },
        {
          title: '所在组织简称',
          [$field]: 'orgShortName'
        },
        {
          title: '撤销日期',
          [$field]: 'revocationTime',
          isEdit: 'true',
          render: (h, {row, index}) => {
            return h('span', timeFormat(row.revocationTime, 'yyyy-MM-dd HH:mm'))
          }
        }
      ]
    },
    //获取数据字典
    getCodeTable (code) {
      this.$set(this.dictMap, code, {})
      return new Promise((resolve, reject) => {
        this.$ajax({
          url: 'api-general/module/portal/user/outGetList',
          method: 'get',
          data: {
            dictCode: code,
            merge: false,
            bizLineCode: 'YWX01'
          }
        }).then(({data}) => {
          this.dictMap[code] = {}
          data.data.length && data.data.forEach(item => {
            if (!this.dictMap[code][item.value]) {
              this.dictMap[code][item.value] = item.title
            }
          })
          resolve()
        })
      })
    }
  },
  components: {
    Modal,
    DragTable,
    FormLayout,
    LayoutTitle
  }
}
</script>